import { RefreshCw, ShieldAlert } from "lucide-react";

import { Button } from "components/ui/Button";
import { PcrsPanel } from "features/pcrsExtension/components/PcrsPanel/PcrsPanel";
import { warmUpPcrsCertificate } from "features/pcrsExtension/utils/pcrsExtensionBridge";

import styles from "./PcrsConnectionFailed.module.css";

// Shown when the extension is installed but PCRS refused or couldn't be
// reached. The browser reports a missing certificate, a wrongly chosen one and
// PCRS being down the same way ("Failed to fetch"), so this points at the
// likeliest fix without claiming to know which it is.
export const PcrsConnectionFailed = ({ onRetry, isRetrying = false }) => {
  // Re-sending the warm-up first lets the browser offer a certificate that was
  // installed since the page loaded, before the check runs again.
  const handleRetry = async () => {
    await warmUpPcrsCertificate();
    onRetry();
  };

  return (
    <PcrsPanel
      icon={ShieldAlert}
      tone="error"
      title="Cannot connect to PCRS."
      lead="Check that your practice's PCRS client certificate is installed on this computer, then try again. If it is, PCRS may be temporarily unavailable. For further questions, contact Kinesin support."
      data-testid="pcrs-connection-failed"
    >
      <div className={styles.actions}>
        <Button
          variant="outline"
          size="small"
          startIcon={RefreshCw}
          onClick={handleRetry}
          disabled={isRetrying}
          data-testid="pcrs-connection-retry"
        >
          {isRetrying ? "Trying…" : "Try again"}
        </Button>
      </div>
    </PcrsPanel>
  );
};
